export const namespaced = true;
export const state = {
    reservationDetailsDialog: {
        isOpen: false,
        reservationId: null,
        openTab: 'main'
    },
    createDialog: {
        isOpen: false,
        prefill: null
    },
    editItemDialog: {
        isOpen: false,
        item: null
    },
    cancelItemDialog: {
        isOpen: false,
        item: null
    },
    checkInResultDialog: {
        isOpen: false,
        item: null
    }
};
export const mutations = {
    OPEN_DIALOG(state, reservationId) {
        state.reservationDetailsDialog.isOpen = true;
        state.reservationDetailsDialog.reservationId = reservationId;
    },
    CLOSE_DIALOG(state) {
        state.reservationDetailsDialog.isOpen = false;
    },
    SET_DIALOG_OPEN_TAB(state, val) {
        state.reservationDetailsDialog.openTab = val;
    },
    OPEN_CREATE_DIALOG(state, prefill) {
        state.createDialog.isOpen = true;
        state.createDialog.prefill = prefill ?? null;
    },
    CLOSE_CREATE_DIALOG(state) {
        state.createDialog.isOpen = false;
        state.createDialog.prefill = null;
    },
    OPEN_EDIT_ITEM_DIALOG(state, item) {
        state.editItemDialog.isOpen = true;
        state.editItemDialog.item = item;
    },
    CLOSE_EDIT_ITEM_DIALOG(state) {
        state.editItemDialog.isOpen = false;
        state.editItemDialog.item = null;
    },
    OPEN_CANCEL_ITEM_DIALOG(state, item) {
        state.cancelItemDialog.isOpen = true;
        state.cancelItemDialog.item = item;
    },
    CLOSE_CANCEL_ITEM_DIALOG(state) {
        state.cancelItemDialog.isOpen = false;
        state.cancelItemDialog.item = null;
    },
    OPEN_CHECK_IN_RESULT_DIALOG(state, item) {
        state.checkInResultDialog.isOpen = true;
        state.checkInResultDialog.item = item;
    },
    CLOSE_CHECK_IN_RESULT_DIALOG(state) {
        state.checkInResultDialog.isOpen = false;
        state.checkInResultDialog.item = null;
    }
};
export const actions = {
    openDialogById({ commit }, { reservationId, startTab }) {
        commit('OPEN_DIALOG', reservationId);
        commit('SET_DIALOG_OPEN_TAB', startTab || 'main');
    },
    closeDialog({ commit }) {
        commit('CLOSE_DIALOG');
    },
    openCreateDialog({ commit }, prefill) {
        commit('OPEN_CREATE_DIALOG', prefill ?? null);
    },
    closeCreateDialog({ commit }) {
        commit('CLOSE_CREATE_DIALOG');
    },
    openEditItemDialog({ commit }, item) {
        commit('OPEN_EDIT_ITEM_DIALOG', item);
    },
    closeEditItemDialog({ commit }) {
        commit('CLOSE_EDIT_ITEM_DIALOG');
    },
    openCancelItemDialog({ commit }, item) {
        commit('OPEN_CANCEL_ITEM_DIALOG', item);
    },
    closeCancelItemDialog({ commit }) {
        commit('CLOSE_CANCEL_ITEM_DIALOG');
    },
    openCheckInResultDialog({ commit }, item) {
        commit('OPEN_CHECK_IN_RESULT_DIALOG', item);
    },
    closeCheckInResultDialog({ commit }) {
        commit('CLOSE_CHECK_IN_RESULT_DIALOG');
    }
};
